var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPointAnimated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "cache-id": "c360354519b04a47b4730423e5562f0f",
    id: "eMs9mjopN6g1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 667 667",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eMs9mjopN6g2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eMs9mjopN6g3",
    transform: "matrix(1 0 0 1 202.158493 130.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eMs9mjopN6g4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "eMs9mjopN6g5",
    d: "M115.5,64C87.057335,64,64,87.057335,64,115.5C64,143.942665,87.057335,167,115.5,167C143.942665,167,167,143.942665,167,115.5C167,87.057335,143.942665,64,115.5,64ZM115.5,81C134.553824,81,150,96.446176,150,115.5C150,134.553824,134.553824,150,115.5,150C96.446176,150,81,134.553824,81,115.5C81,96.446176,96.446176,81,115.5,81Z",
    opacity: 0,
    fill: "rgb(0,0,0)",
    stroke: "none",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "eMs9mjopN6g6",
    d: "M115.5,32C69.384223,32,32,69.384223,32,115.5C32,161.615777,69.384223,199,115.5,199C161.615777,199,199,161.615777,199,115.5C199,69.384223,161.615777,32,115.5,32ZM115.5,49C152.226936,49,182,78.773064,182,115.5C182,152.226936,152.226936,182,115.5,182C78.773064,182,49,152.226936,49,115.5C49,78.773064,78.773064,49,115.5,49Z",
    opacity: 0,
    fill: "rgb(0,0,0)",
    stroke: "none",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "eMs9mjopN6g7",
    d: "M115.5,0C51.711111,0,0,51.711111,0,115.5C0,179.288889,51.711111,231,115.5,231C179.288889,231,231,179.288889,231,115.5C231,51.711111,179.288889,0,115.5,0ZM115.5,17C169.900048,17,214,61.099952,214,115.5C214,169.900048,169.900048,214,115.5,214C61.099952,214,17,169.900048,17,115.5C17,61.099952,61.099952,17,115.5,17Z",
    opacity: 0,
    fill: "rgb(0,0,0)",
    stroke: "none",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "eMs9mjopN6g8_to",
    transform: "translate(20,170)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eMs9mjopN6g8",
    transform: "translate(0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "eMs9mjopN6g9",
    d: "M80,352L80,304L96,304L96,336L224,336L224,304L240,304L240,352L80,352ZM256,256L256,304L240,304L240,256L256,256ZM80,272L80,304L64,304L64,272L80,272ZM64,240L64,272L48,272L48,240L64,240ZM272,144L272,256L256,256L256,144L272,144ZM48,208L48,240L32,240L32,208L48,208ZM32,192L32,208L16,208L16,192L32,192ZM32,144L32,160L16,160L16,192L0,192L0,144L32,144ZM80,16L80,192L64,192L64,176L48,176L48,160L64,160L64,16L80,16ZM240,112L240,128L224,128L224,176L208,176L208,112L240,112ZM48,144L48,160L32,160L32,144L48,144ZM208,96L208,112L176,112L176,160L160,160L160,96L208,96ZM128,16L128,80L160,80L160,96L128,96L128,160L112,160L112,16L128,16ZM256,128L256,144L240,144L240,128L256,128ZM112,0L112,16L80,16L80,0L112,0Z",
    fill: "rgb(0,0,0)",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "eMs9mjopN6g10",
    d: "M16,160C15.545078,181.333333,15.545078,192,16,192C16.454922,192,21.788256,192,32,192L32,208L48,208L48,240L64,240L64,272L80,272L80,304L96,304L96,336L224,336L224,304L240,304L240,256L256,256L256,144L240,144L240,128L224,128L224,176L208,176L208,112L176,112L176,160L160,160L160,96L128,96L128,160L112,160L112,16L80,16L80,192L64,192L64,176L48,176L48,160L16,160Z",
    fill: "rgb(255,255,255)",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointAnimated);
export default __webpack_public_path__ + "static/media/point-animated.3c71e329ec4bdfd69b51db7c6ffba6e2.svg";
export { ForwardRef as ReactComponent };